export default __webpack_public_path__ + "static/founders-grotesk-light-7c59d5d36b710b93d558569f56f495e6.woff2";